<p class="heading">Tell us about your requirement?</p>

<form [formGroup]="loanInfoFormGroup" (ngSubmit)="onSubmit(loanInfoFormGroup)">

    <p class="form-field-heading">Required loan amount</p>
    <div class="row">
        <mat-form-field class="col-xs-12">
            <span matPrefix>₹&nbsp;</span>
            <input formControlName="amount" matInput [placeholder]=amountPlaceholder type="number" step="5000"
                   max="500000">
            <mat-error>{{ getErrorMessage(loanInfoFormGroup.controls.amount) }}</mat-error>
        </mat-form-field>
    </div>

    <p class="form-field-heading">Purpose of loan</p>
    <div class="row">
        <mat-form-field class="col-xs-12">
            <mat-select placeholder="Select purpose" formControlName="reason" (selectionChange)="onLoanReasonChange()">
                <mat-option *ngFor="let reason of reasons()" value="{{ reason }}">
                    {{ reason }}
                </mat-option>
            </mat-select>
            <mat-error>{{ getErrorMessage(loanInfoFormGroup.controls.reason) }}</mat-error>
        </mat-form-field>
    </div>

    <div *ngIf="loanInfoFormGroup.value.reason === Others.valueOf()" class="row">
        <br/>
        <mat-form-field class="col-xs-12">
            <input formControlName="reasonDescription" matInput placeholder="Details of loan purpose">
            <mat-error>{{ getErrorMessage(loanInfoFormGroup.controls.reasonDescription) }}</mat-error>
        </mat-form-field>
    </div>

    <p class="form-field-heading">Loan Tenure</p>
    <div *ngIf="!hasIndicativeEligibilityCheck">
        <mat-form-field style="width: 100%">
            <mat-select placeholder="Select tenure in months" formControlName="tenure">
                <mat-option *ngFor="let tenure of tenures()" value="{{ tenure }}">
                    {{ tenure }} months
                </mat-option>
            </mat-select>
            <mat-error>{{ getErrorMessage(loanInfoFormGroup.controls.tenure) }}</mat-error>
        </mat-form-field>
        <p class="sub-text">*Prepay anytime. No prepayment penalties.</p>
    </div>

    <div *ngIf="hasIndicativeEligibilityCheck">
        <mat-form-field style="width: 100%">
            <input formControlName="tenure" matInput type="number" readonly name="tenure"
                   placeholder="Tenure in months">
        </mat-form-field>
        <p class="sub-text">*Prepay anytime. No prepayment penalties.</p>
    </div>

    <div class="row">
        <div class="col-xs-6">
            <button mat-stroked-button class="button-back primary" type="button" (click)="previousPage()">
                <i class="material-icons">arrow_back</i>&nbsp;&nbsp;&nbsp;BACK
            </button>
        </div>
        <div class="col-xs-6">
            <div class="pull-right">
                <app-forward-button class="button-forward" [isLoading]="shouldShowLoader"
                                    (click)="analyticsTracker.trackButtonClick('Loan Information', 'Next')">
                    NEXT
                </app-forward-button>
            </div>
        </div>
    </div>
</form>
